import {
  FETCH_SEASON_RANKINGS,
  FETCH_AVAILABLE_RANKINGS,
  FETCH_LAST_RANKING_RUN,
  FETCH_SEASON_WEEKS,
  RUN_SEASON_RANKINGS,
  PUBLISH_RANKINGS
} from '../actions'

export default function (state = {}, action) {

  switch (action.type) {

    case FETCH_SEASON_RANKINGS:
      {
        const rankings = action.payload.data
        return Object.assign({}, state, {
          values: {
            ...state.values,
            rankings
          },
          fields: {
            ...state.values,
            rankings
          }
        })
      }
    case FETCH_AVAILABLE_RANKINGS:
      {
        const availablerankings = action.payload.data
        const seasonId = (availablerankings != null) ? availablerankings[0].seasonId : 0
        const rankings = []
        return Object.assign({}, state, {
          values: {
            ...state.values,
            availablerankings,
            seasonId,
            rankings
          },
          fields: {
            ...state.values,
            availablerankings,
            seasonId,
            rankings
          }
        })
      }
    case FETCH_LAST_RANKING_RUN:
      {
        const lastrankings = action.payload.data
        const season = (lastrankings != null) ? lastrankings.season : 0
        return Object.assign({}, state, {
          values: {
            ...state.values,
            lastrankings,
            season
          },
          fields: {
            ...state.values,
            lastrankings,
            season
          }
        })
      }
    case FETCH_SEASON_WEEKS:
      {
        const seasonweeks = action.payload.data
        const weekNumber = (seasonweeks != null) ? seasonweeks[0].weekNumber : 0
        return Object.assign({}, state, {
          values: {
            ...state.values,
            seasonweeks,
            weekNumber
          },
          fields: {
            ...state.fields,
            seasonweeks,
            weekNumber
          }
        })
      }
    case RUN_SEASON_RANKINGS:
      {
        const rankingRunStarted = true

        return Object.assign({}, state, {
          values: {
            ...state.values,
            rankingRunStarted
          },
          fields: {
            ...state.fields,
            rankingRunStarted
          }
        })
      }
    case PUBLISH_RANKINGS:
      {
        const rankingPublicationStarted = true

        return Object.assign({}, state, {
          values: {
            ...state.values,
            rankingPublicationStarted
          },
          fields: {
            ...state.fields,
            rankingPublicationStarted
          }
        })
      }
    default:
      return state
  }


}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_season.js